export default {
    id: null,
    person: null,
    notify: true,
    acl: null,
    active: true
}
